import { GridApi } from 'ag-grid-community';
import { HierarchyColumnConfig, OrderConfig } from 'common/visualizations/vif';
import { useCallback } from 'react';
import { renderIndentedHeader, renderUnindentedHeader } from '../helpers/customSortRenders';

export type UseRenderUnindentedHeaderProps = {
  isIndented: boolean | undefined;
  gridApi: GridApi | null;
  hierarchyColumns: HierarchyColumnConfig[];
  vifOrderConfig: OrderConfig[];
};

export const useRenderUnindentedHeader = (props: UseRenderUnindentedHeaderProps) => {
  const { isIndented, gridApi, hierarchyColumns, vifOrderConfig } = props;
  return useCallback(renderUnindentedHeader, [gridApi, vifOrderConfig, hierarchyColumns, isIndented]);
};

export type UseRenderIndentedHeaderProps = {
  isIndented: boolean | undefined;
  headerSortCycleIndex: number;
  gridApi: GridApi | null;
  vifOrderConfig: OrderConfig[];
  hierarchyColumns: HierarchyColumnConfig[];
  sortSourceElement: string | null;
};

export const useRenderIndentedHeader = (props: UseRenderIndentedHeaderProps) => {
  const { gridApi, vifOrderConfig, hierarchyColumns, isIndented, headerSortCycleIndex, sortSourceElement } =
    props;
  return useCallback(renderIndentedHeader, [
    gridApi,
    vifOrderConfig,
    hierarchyColumns,
    isIndented,
    headerSortCycleIndex,
    sortSourceElement,
  ]);
};
